import axios_nomura from './axios-nomura.services';

// Search Fund
export const fetchFundSearch = async (body) => {
  return await axios_nomura.post(`api/v1/funds/search`, body);
};

// Portfolio info
export const fetchPortfolioInformation = async (fundId) => {
	return await axios_nomura.get(`/api/v1/funds/${fundId}/portfolio`);
};

// Fund Info
export const fetchFundInfo = async (fundId) => {
	return await axios_nomura.get(`api/v1/funds/${fundId}`);
};

export const fetchTradingInformation = async (fundId) => {
	return await axios_nomura.get(`api/v1/funds/${fundId}/trading_information`);
};

export const fetchFundAverageRating = async (fundId) => {
	return await axios_nomura.get(`api/v1/funds/${fundId}/average_rating`);
};

export const getUserFundVote = async (fundId) => {
	return await axios_nomura.get(`api/v1/funds/${fundId}/vote`);
};

export const voteFundAverageRating = async (data) => { //postUserFundVote
	return await axios_nomura.post(`api/v1/funds/${data.fundId}/vote`, { rating: parseInt(data.rating)});
};

// Port Info
export const fetchPortChartByFundIdAndChartType = async (data) => {
	return await axios_nomura.get(`api/v1/funds/${data.fundId}/top_holding`, { params: { holdingType: data.chartType } });
};

export const fetchPortByFundId = async (fundId) => {
	return await axios_nomura.get(`/api/v1/funds/${fundId}/portfolio`);
};

// Statistic
export const fetchDrawdownByDate = async (data) => {
	return await axios_nomura.get(`api/v1/statistics/${data.fundId}/drawdowns`, { params: { start: data.startDate ?? '', end: data.endDate ?? '' }});
};

export const fetchMaximumDrawdown = async (fundCode) => {
	return await axios_nomura.get(`api/v1/statistics/${fundCode}/max_drawdown`);
};

export const fetchMonthlyReturn = async (fundCode) => {
	return await axios_nomura.get(`api/v1/statistics/${fundCode}/monthly_return`);
};

export const fetchPriceRange = async (fundCode) => {
	return await axios_nomura.get(`api/v1/statistics/${fundCode}/price_range`);
};

export const fetchVolatilities = async (data) => {
	return await axios_nomura.get(`api/v1/statistics/${data.fundId}/volatility`, {params: {start: data.startAt ?? '', end: data.endAt ?? ''}});
};

export const fetchReturnExpenseRatio = async (fundCode) => {
	return await axios_nomura.get(`/api/v1/statistics/${fundCode}/expense_ratio`);
};

export const fetchMonthlyProfit = async (fundCode) => {
	return await axios_nomura.get(`/api/v1/statistics/${fundCode}/profit`);
};

export const fetchReturnHistory = async (fundCode) => {
	return await axios_nomura.get(`/api/v1/statistics/${fundCode}/previous_return`);
};

export const fetchWeeklyFundRanking = async (data) => {
	return await axios_nomura.get(`/api/v1/statistics/${data.fundId}/rank?startDate=${data.startDate ?? ''}&endDate=${data.endDate ?? ''}`);
};

// Graph Info
export const fetchHistoricalNav = async (data) => {
	return await axios_nomura.get(`api/v1/nav/${data.fundId}`, { params: { page: data.page, pageSize: data.pageSize , startDate: data.startDate ?? '', endDate: data.endDate ?? '' } });
};

// Historical Nav
export const fetchHistoricalNavGraph = async (data) => {
	return await axios_nomura.get(`api/v1/nav/${data.fundId}/graph`, { params: { startDate: data.startDate ?? '', endDate: data.endDate ?? '', mode: data.mode } });
};

// Dividend
export const fetchDividend = async (data) => {
	return await axios_nomura.get(`api/v1/dividend/${data.fundId}`, { params: { startDate: data.startDate ?? '', endDate: data.endDate ?? '', page: data.page ?? 1 } });
};

export const fetchDividendDescription = async (fundId) => {
	return await axios_nomura.get(`api/v1/dividend/${fundId}`);
};

export const fetchDividendGroupByYear = async (fundId) => {
	return await axios_nomura.get(`api/v1/dividend/${fundId}/group`);
};

export const fetchNavChartByDate = async (data) => {
	return await axios_nomura.get(`api/v1/nav/${data.fundCode}`, { params: { startDate: data.startDate ?? '', endDate: data.endDate ?? '' } });
};
